import { IconButton, Typography, useTheme } from "@mui/material";
import { Box } from "@mui/system";
import React, { useState } from "react";
//import buzzlogo from "../../assets/buzz.png";
import PersonPinCircleIcon from "@mui/icons-material/PersonPinCircle";
import { tokens } from "../../Theme/theme";
import StorefrontIcon from "@mui/icons-material/Storefront";
import "react-pro-sidebar/dist/css/styles.css";
import PermIdentityIcon from "@mui/icons-material/PermIdentity";
import '../../assets/fonts/fonts.css'
import buzzlogo from "../../assets/cerkle_admin_logo.svg";
import { Link, useNavigate } from "react-router-dom";


import { ProSidebar, Menu, MenuItem } from "react-pro-sidebar";
import NotificationsPausedIcon from "@mui/icons-material/NotificationsPaused";
import {
  ChatBubbleSharp,
  ChatSharp,
  GridViewRounded,
  FlutterDashOutlined,
  PeopleOutlineRounded,
  Map,
  MapsHomeWork,
  MenuOutlined,
  NotificationsActiveOutlined,
  SupervisedUserCircle,
  VerifiedUserRounded,
  KeyboardDoubleArrowRightRounded,
  KeyboardDoubleArrowLeftRounded,
  BroadcastOnPersonal,
  LocalFireDepartmentRounded,
  LocalFireDepartmentOutlined,
  MoneyOffCsredRounded,
  MoneyRounded,
  Receipt,
  LinkRounded,
  SubscriptionsOutlined,
  EventAvailableOutlined,
  ChatBubbleOutline,
  SpaceBarRounded,
  CircleRounded,
  Groups2Outlined,
  AnimationRounded,
  WorkOffOutlined,
  WorkOutline
} from "@mui/icons-material";
const Item = ({ title, to, icon, selected, setselected }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();


  const handlelogout = () => {
    localStorage.removeItem("token");
    navigate("/", { replace: true });
  };

  return (
    <MenuItem
      active={selected === title}
      style={{ color: colors.grey[100], padding: 0, margin: 0 }}
      onClick={() => setselected(title)}

      icon={icon}
    >
      <Typography variant="h6" fontFamily={"poppins-reg"}>{title}</Typography>
      <Link to={to}></Link>
    </MenuItem>
  );
};
const Sidebar = ({ data, onClick, mobile }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  // console.log(Date.to);
  const [isCollapsed, setisCollapsed] = useState(false);
  const [selected, setselected] = useState("Dashboard");
  return (
    <Box

      sx={{
        position: 'fixed',
        height: "100%",
        flex: 1,
        zIndex: 30,
        alignSelf: 'stretch',
        "& .pro-sidebar-inner": {
          background: "#000000ff !important",
        },

        "& .pro-icon-wrapper": {
          backgroundColor: "transparent !important",
        },
        "& .pro-inner-item": {
          padding: "5px 12px 5px 12px !important",
        },
        "& .pro-inner-item:hover": {
          color: "#ffffff40 !important",

        },
        "& .pro-menu-item.active": {
          color: "#ffffff !important",
          backgroundColor: "#ffffff10",
          borderRadius: '10px',
        },
        "& .pro-sidebar ": {
          height: "100%",
          // position: "relative",
        },

        "& .pro-sidebar-content ": {
          height: "200%",
        },
      }}
    >
      <ProSidebar style={{ width: "300px", }} collapsed={isCollapsed}>
        <Menu iconShape="square" style={{ padding: 0 }}>
          <MenuItem
            style={{
              color: colors.grey[100],
              paddingBlock: "21.5px",
              borderBottom: "1px solid #aaaaaa20"
            }}
          >

            <Box
              display="flex"
              alignItems="center"
            // position={"sticky"}
            >

              <Box
                sx={{
                  justifyItems: 'center',
                  borderRadius: "100%",
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginLeft: "9px",
                  alignContent: 'center',
                  display: 'flex',
                }} >
                <img
                  alt="profile-user"
                  width="150px"
                  height="30px"
                  style={{ cursor: "pointer", objectFit: 'contain', }}
                  src={buzzlogo}
                />
              </Box>
            </Box>
          </MenuItem>

          <Typography style={{
            fontFamily: "poppins-reg", fontSize: "12px", color: "#aaaaaa",
            marginInline: "27px", marginTop: "25px"
          }} >General</Typography>

          <Box pl={"2%"} pr={"2%"} mt={"5px"}>
            <Item
              title={"Dashboard"}
              to="/admin/dashboard"
              icon={<GridViewRounded />}
              selected={selected}
              setselected={setselected}
            />
            {/* //Appointments */}
            {/* <Typography
              variant="h6"
              color={colors.grey[300]}
              sx={{ m: "15px 0 5px 20px" }}
            >
              Appointments
            </Typography> */}

            <Item
              title={"Communities"}
              to="/admin/communities"
              icon={<LocalFireDepartmentOutlined />}
              selected={selected}
              setselected={setselected}
            />

            <Item
              title={"Spaces"}
              to="/admin/spaces"
              icon={<AnimationRounded />}
              selected={selected}
              setselected={setselected}
            />

            {
              data.Role == "ADMIN" && (
                <Item
                  title={"Subscriptions"}
                  to="/admin/subscriptions"
                  icon={<SubscriptionsOutlined />}
                  selected={selected}
                  setselected={setselected}
                />
              )
            }


            <Item
              title={"Users"}
              to="/admin/users"
              icon={<PeopleOutlineRounded />}
              selected={selected}
              setselected={setselected}
            />

            {/* <Item
              title={"Referrals"}
              to="/admin/referrals"
              icon={<MoneyRounded />}
              selected={selected}
              setselected={setselected}
            /> */}
            <Item
              title={"Events"}
              to="/admin/events"
              icon={<EventAvailableOutlined />}
              selected={selected}
              setselected={setselected}
            />

            <Item
              title={"Jobs & Internships"}
              to="/admin/jobs"
              icon={<WorkOutline />}
              selected={selected}
              setselected={setselected}
            />

            <Item
              title={"User Content"}
              to="/admin/user-content"
              icon={<Receipt />}
              selected={selected}
              setselected={setselected}
            />

            <Box sx={{ alignSelf: 'stretch', height: "1px", background: "#aaaaaa20", marginBlock: "15px" }} />
            <Typography style={{
              fontFamily: "poppins-reg", fontSize: "12px", color: "#aaaaaa",
              marginInline: "20px", marginTop: "20px", marginBottom: "5px"
            }} >Other</Typography>



            <Item
              title={"Live Users"}
              to="/admin/liveusers"
              icon={<PersonPinCircleIcon />}
              selected={selected}
              setselected={setselected}
            />
            <Item
              title={"Chats & Matches"}
              to="/admin/chatsandmatches"
              icon={<ChatBubbleOutline />}
              selected={selected}
              setselected={setselected}
            />
            <Item
              title={"Active Users"}
              to="/admin/activeusers"
              icon={<PermIdentityIcon />}
              selected={selected}
              setselected={setselected}
            />
            <Item
              title={"Chirps"}
              to="/admin/chirps"
              icon={<FlutterDashOutlined />}
              selected={selected}
              setselected={setselected}
            />
            <Item
              title={"Send Notification"}
              to="/admin/notify"
              icon={<NotificationsPausedIcon />}
              selected={selected}
              setselected={setselected}
            />

            <Item
              title={"Link Shortner"}
              to="/admin/sm-links"
              icon={<LinkRounded />}
              selected={selected}
              setselected={setselected}
            />
          </Box>
        </Menu>
      </ProSidebar>
    </Box>
  );
};

export default Sidebar;
